// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"3eeccd08","349":"f60e1164","554":"64cc661c","772":"08b5810a","812":"2abb6faa"}[chunkId] + ".chunk.js";
};